import React, { Component, Fragment } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import HomestayRoomTypeList from './HomestayRoomTypeList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class HomestayRoomTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                homestayId: this.props.match.params.homestay_id,
                pageSize: this.props.homestayRoomTypeState.pageSize,
                pageIndex: this.props.homestayRoomTypeState.pageIndex,
            }
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ROOM_TYPE);
        this.props.getListHomestayRoomTypes(this.state.filters);
        if(this.state.filters?.homestayId){
            this.props.getHomestayDetail(this.state.filters.homestayId);
        }
    }

    render() {
        const { t, match, homestayState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, dataList } = this.props.homestayRoomTypeState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex};

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'homestayRoomType'}
                        titleHeader={`${t('navigation.homestayRoomTypes')} - ${homestayState?.detail?.homestay?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>{
                                // permisionActions && permisionActions.allowCreate &&
                                // <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                //     <Link to={Func.getPathWithParams(PATHS.ROOM_TYPE.CREATE.path, {homestay_id: match.params.homestay_id})}
                                //         className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                // </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <HomestayRoomTypeList loading={isFetching}
                        homestayId={match.params.homestay_id}
                        permisions={permisionActions}
                        dataList={dataList}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteHomestayRoomType={this.onDeleteHomestayRoomType}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        newFilters.homestayId = this.props.match.params.homestay_id;
        this.setState({
            filters: newFilters
        });
        this.props.getListHomestayRoomTypes(newFilters);
    };

    onDeleteHomestayRoomType = (item) => {
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.homestay_id) {
            const path = Func.getPathWithParams(PATHS.HOMESTAY.DETAIL.path, { id: match.params.homestay_id })
            this.props.history.push(path);
        }
    }

    onChangeLanguage = (language) => {
        this.props.getListHomestayRoomTypes(this.state.filters)
    }
}